/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface FinancingLoansActivation {
    activationStatus: FinancingLoansActivationStatus;
    activationMethod: FinancingLoansActivationMethod;
}

export enum FinancingLoansActivationMethod {
    Email = 'email',
    Phone = 'phone',
    EmailPhone = 'emailPhone',
}

export enum FinancingLoansActivationStatus {
    NotSet = 'notSet',
    Pending = 'pending',
    Activated = 'activated',
    NotActivated = 'notActivated',
}

export interface FinancingLoansChargeInfo {
    available: boolean;
    reasonCode?: string | null;
}

export enum FinancingLoansLoanApplicationSubmitSource {
    Unknown = 'unknown',
    Mobile = 'mobile',
    OnlineEstimates = 'onlineEstimates',
    Estimate = 'estimate',
    Project = 'project',
    Invoice = 'invoice',
}

export interface FinancingLoansLoanAuthorization {
    /** @format double */
    amount: number;
    /** @format date-time */
    requestedAt: string;
    status: FinancingLoansLoanAuthorizationAuthorizationStatus;
}

export enum FinancingLoansLoanAuthorizationAuthorizationStatus {
    None = 'none',
    Pending = 'pending',
    Confirmed = 'confirmed',
    Declined = 'declined',
}

export enum FinancingLoansLoanStatus {
    NotSet = 'notSet',
    AboutToSubmit = 'aboutToSubmit',
    Declined = 'declined',
    Approved = 'approved',
    Review = 'review',
    Signed = 'signed',
    Error = 'error',
    Invalid = 'invalid',
    CounterOffer = 'counterOffer',
    NotSigned = 'notSigned',
    ActivationRequested = 'activationRequested',
    Submitted = 'submitted',
    Cancelled = 'cancelled',
    Expired = 'expired',
    Conditional = 'conditional',
    Prequalified = 'prequalified',
}

export interface FinancingLoansStipulation {
    id?: string | null;
    name?: string | null;
    description?: string | null;
    status?: string | null;
    appliesTo?: string | null;
}

export interface FintechSharedContractsErrorInfo {
    errorCode?: string | null;
    description?: string | null;
    invalidParameter?: string | null;
    invalidValue?: string | null;
    failedSource: FintechSharedContractsFailedStatusSource;
}

export enum FintechSharedContractsFailedStatusSource {
    NotSet = 'notSet',
    Provider = 'provider',
    UserInput = 'userInput',
    Backend = 'backend',
}

export enum PaymentsLoansAuthorizationStatus {
    None = 'none',
    Pending = 'pending',
    Confirmed = 'confirmed',
    Declined = 'declined',
}

export interface PaymentsLoansChargeInfo {
    available: boolean;
    reasonCode?: string | null;
}

export interface PaymentsLoansLoan {
    externalLoanId?: string | null;
    financingId?: string | null;
    tenantId?: string | null;
    jobId?: string | null;
    businessUnitId?: string | null;
    applicantLastName?: string | null;
    customerId?: string | null;
    /** @format date-time */
    appliedOn: string;
    /** @format date-time */
    expiresOn: string;
    /** @format double */
    availableCredit: number;
    providerName?: string | null;
    chargeInfo: PaymentsLoansChargeInfo;
    creditCardUid?: string | null;
    /** @format double */
    saleAmount: number;
    /** @format double */
    down: number;
    /** @format double */
    requestedAmount: number;
    /** @format double */
    approvedAmount?: number | null;
    hasCoApplicant: boolean;
    technicianId?: string | null;
    planDescription?: string | null;
    planNumber?: string | null;
    displayAccountNumber?: string | null;
    authorizationStatus: PaymentsLoansAuthorizationStatus;
}

export enum PaymentsPaymentMethodsActionSource {
    NotSet = 'notSet',
    TechnicianApp = 'technicianApp',
    BackofficeDesktop = 'backofficeDesktop',
    Api = 'api',
    ExternalApi = 'externalApi',
    CustomerPortal = 'customerPortal',
    PaymentsService = 'paymentsService',
}

export interface PaymentsPaymentMethodsCreditCardRead {
    name?: string | null;
    lastFourNumber?: string | null;
    firstSixNumber?: string | null;
    /** @format date-time */
    expiration: string;
    postalCode?: string | null;
    customerVaultId?: string | null;
    accountId?: string | null;
    provider: PaymentsPaymentMethodsProviderType;
    cardType?: string | null;
    isPrimary: boolean;
    id?: string | null;
    applicationId?: string | null;
    groupId?: string | null;
    organizationId?: string | null;
    externalCustomerId?: string | null;
    type: PaymentsPaymentMethodsPaymentMethodType;
    status: PaymentsPaymentMethodsPaymentMethodStatus;
    isActive: boolean;
    /** @format date-time */
    updatedAt: string;
    statusHistory?: PaymentsPaymentMethodsPaymentMethodStatus[] | null;
    actionSource: PaymentsPaymentMethodsActionSource;
}

export interface PaymentsPaymentMethodsPaymentMethodStatus {
    status: PaymentsPaymentMethodsPaymentMethodStatusCode;
    customerVaultId?: string | null;
    message?: string | null;
    /** @format date-time */
    appliedAt: string;
    source: PaymentsPaymentMethodsActionSource;
}

export enum PaymentsPaymentMethodsPaymentMethodStatusCode {
    NotSet = 'notSet',
    Created = 'created',
    Updated = 'updated',
    Deleted = 'deleted',
    Expired = 'expired',
    Error = 'error',
}

export enum PaymentsPaymentMethodsPaymentMethodType {
    NotSet = 'notSet',
    CreditCard = 'creditCard',
    Ach = 'ach',
    Mrdc = 'mrdc',
    PayByBank = 'payByBank',
}

export interface PaymentsPaymentMethodsPostCreditCardWrite {
    provider: PaymentsPaymentMethodsProviderType;
    name?: string | null;
    lastFourNumber?: string | null;
    firstSixNumber?: string | null;
    /** @format date-time */
    expiration: string;
    postalCode?: string | null;
    customerVaultId?: string | null;
    externalCustomerId?: string | null;
    groupId?: string | null;
    organizationId?: string | null;
    applicationId?: string | null;
    accountId?: string | null;
    cardType?: string | null;
    isPrimary: boolean;
    actionSource: PaymentsPaymentMethodsActionSource;
}

export enum PaymentsPaymentMethodsProviderType {
    NotSet = 'notSet',
    Nmi = 'nmi',
    ProfitStars = 'profitStars',
    PayEngine = 'payEngine',
    PaymentsService = 'paymentsService',
}

export interface PaymentsPaymentRead {
    id?: string | null;
    status: PaymentsPaymentStatus;
    /** @format date-time */
    submittedAt: string;
    externalTransactionId?: string | null;
    statusHistory?: PaymentsPaymentStatus[] | null;
    tenantId?: string | null;
    businessUnitId?: string | null;
    customerId?: string | null;
    accountingPaymentId?: string | null;
    invoiceNumber?: string | null;
    /** @format double */
    amount: number;
    /** @format double */
    totalJobAmount: number;
    jobId?: string | null;
    jobCompleted: boolean;
    externalPaymentMethodId?: string | null;
    paymentMethodId?: string | null;
    type: PaymentsPaymentType;
    source: PaymentsPaymentSource;
}

export enum PaymentsPaymentSource {
    System = 'system',
    Desktop = 'desktop',
    Mobile = 'mobile',
    CustomerPortal = 'customerPortal',
}

export interface PaymentsPaymentStatus {
    status: PaymentsPaymentStatusCode;
    tag?: string | null;
    description?: string | null;
    /** @format date-time */
    appliedAt: string;
}

export enum PaymentsPaymentStatusCode {
    NotSet = 'notSet',
    Pending = 'pending',
    Rejected = 'rejected',
    Completed = 'completed',
    Error = 'error',
    Invalid = 'invalid',
}

export enum PaymentsPaymentType {
    NotSet = 'notSet',
    GreenSky = 'greenSky',
    Synchrony = 'synchrony',
    WellsFargo = 'wellsFargo',
}

export interface PaymentsPaymentWrite {
    tenantId?: string | null;
    businessUnitId?: string | null;
    customerId?: string | null;
    accountingPaymentId?: string | null;
    invoiceNumber?: string | null;
    /** @format double */
    amount: number;
    /** @format double */
    totalJobAmount: number;
    jobId?: string | null;
    jobCompleted: boolean;
    externalPaymentMethodId?: string | null;
    paymentMethodId?: string | null;
    type: PaymentsPaymentType;
    source: PaymentsPaymentSource;
}

export interface PaymentsServiceContractsRequestsLoansUpsertLoan {
    id?: string | null;
    externalLoanId?: string | null;
    status: FinancingLoansLoanStatus;
    statusReason?: string | null;
    planNumber?: string | null;
    planDescription?: string | null;
    /** @format int32 */
    term?: number | null;
    /** @format double */
    rate?: number | null;
    tenantId?: string | null;
    buId?: string | null;
    customerId?: string | null;
    jobId?: string | null;
    /** @format double */
    saleAmount: number;
    /** @format double */
    down: number;
    /** @format double */
    requestedAmount: number;
    /** @format double */
    approvedAmount?: number | null;
    /** @format double */
    payment?: number | null;
    hasCoApplicant: boolean;
    providerName?: string | null;
    source: FinancingLoansLoanApplicationSubmitSource;
    sourceId?: string | null;
    technicianId?: string | null;
    primaryApplicantLastName?: string | null;
    improvement?: string | null;
    /** @format date-time */
    createdAt: string;
    /** @format date-time */
    updatedAt: string;
    promotionDetails?: string | null;
    creditProduct?: string | null;
    isCounterOffer: boolean;
    /** @format int32 */
    promotionPeriod: number;
    isDeferred: boolean;
    applicantEmail?: string | null;
    lender?: string | null;
    merchantReferenceNumber?: string | null;
    isCtaRequired: boolean;
    productDisclosure?: string | null;
    primaryApplicantActivation: FinancingLoansActivation;
    coApplicantActivation: FinancingLoansActivation;
    /** @format date-time */
    appliedOn: string;
    /** @format date-time */
    expiresOn?: string | null;
    /** @format double */
    availableCredit?: number | null;
    creditCardUid?: string | null;
    chargeInfo: FinancingLoansChargeInfo;
    isValid: boolean;
    trainingMessage?: string | null;
    stipulations?: FinancingLoansStipulation[] | null;
    referenceNumber?: string | null;
    expirationDate?: string | null;
    trainingAvailable: boolean;
    trainingUrl?: string | null;
    showTrainingAlert: boolean;
    /** @format date-time */
    lastError?: string | null;
    /** @format int32 */
    errorCount?: number | null;
    applicantDeliveryMethod?: string | null;
    previousStatus: FinancingLoansLoanStatus;
    authorization: FinancingLoansLoanAuthorization;
    displayAccountNumber?: string | null;
}

export interface PaymentsTransactionsHandleTransactionStatusWrite {
    accountId?: string | null;
}

export type CreditcardsCreateData = PaymentsPaymentMethodsCreditCardRead;

export type CreditcardsCreateError = FintechSharedContractsErrorInfo[];

export type LoansUpdateData = any;

export type LoansUpdateError = FintechSharedContractsErrorInfo[];

export interface LoansDetailParams {
    tenantId: string;
    buId: string;
    id: string;
}

export type LoansDetailData = PaymentsLoansLoan;

export interface LoansListParams {
    ProviderName: string;
    CustomerId: string;
    JobId: string;
    ApplicantLastName: string;
    /** @format date-time */
    DateOfBirth: string;
    SsnLast4Digits: string;
    TenantId: string;
    BuId: string;
}

export type LoansListData = PaymentsLoansLoan[];

export type PaymentsDetailData = PaymentsPaymentRead;

export interface PaymentsPartialUpdateParams {
    tenantId: string;
    buId: string;
    forceRepublishing: boolean;
    id: string;
}

export type PaymentsPartialUpdateData = PaymentsPaymentRead;

export type PaymentsPartialUpdateError = FintechSharedContractsErrorInfo[];

export type PaymentsCreateData = PaymentsPaymentRead;

export type PaymentsCreateError = FintechSharedContractsErrorInfo[];

export interface PaymentsPartialUpdate2Params {
    /** @format date-time */
    from: string;
    /** @format date-time */
    to: string;
}

export type PaymentsPartialUpdate2Data = any;

export type PaymentsPartialUpdate2Error = FintechSharedContractsErrorInfo[];

export type TransactionsStatusPartialUpdateData = any;

export type TransactionsStatusPartialUpdateError = FintechSharedContractsErrorInfo[];

import { inject, injectable, optional, symbolToken } from '@servicetitan/react-ioc';
import axios, { AxiosRequestConfig, AxiosResponse, ResponseType } from 'axios';
import { v4 as uuidv4 } from 'uuid';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
    extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
    /** set parameter to `true` for call `securityWorker` for this request */
    secure?: boolean;
    /** request path */
    path: string;
    /** content type of request body */
    type?: ContentType;
    /** query params */
    query?: QueryParamsType;
    /** format of response (i.e. response.json() -> format: "json") */
    format?: ResponseType;
    /** request body */
    body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export enum ContentType {
    Json = 'application/json',
    FormData = 'multipart/form-data',
    UrlEncoded = 'application/x-www-form-urlencoded',
    Text = 'text/plain',
}

export enum RequestOrigin {
    Unknown = 'Unknown',
    Mobile = 'Mobile',
    Desktop = 'Desktop',
    BackgroundJob = 'BackgroundJob',
    Webhook = 'Webhook',
    Redirect = 'Redirect',
    CustomerPortal = 'CustomerPortal',
    CustomerPortal2 = 'CustomerPortal2',
    FMA = 'FMA',
    CPB = 'CPB',
}

@injectable()
export class HttpClient {
    sessionId: string;
    tenantId: string;
    tenantFriendlyName: string;
    actingUserId: string;
    requestOrigin: RequestOrigin;
    financingProvider: string = 'Unspecified';

    constructor(
        sessionId: string,
        tenantId: string,
        tenantFriendlyName: string,
        actingUserId: string,
        requestOrigin: RequestOrigin,
    ) {
        this.sessionId = sessionId;
        this.tenantId = tenantId;
        this.tenantFriendlyName = tenantFriendlyName;
        this.actingUserId = actingUserId;
        this.requestOrigin = requestOrigin;
    }

    public setFinancingProvider(provider: string) {
        this.financingProvider = provider;
    }

    protected stringifyFormItem(formItem: unknown) {
        if (typeof formItem === 'object' && formItem !== null) {
            return JSON.stringify(formItem);
        } else {
            return `${formItem}`;
        }
    }

    protected createFormData(input: Record<string, unknown>): FormData {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            const propertyContent: any[] = property instanceof Array ? property : [property];

            for (const formItem of propertyContent) {
                const isFileType = formItem instanceof Blob || formItem instanceof File;
                formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
            }

            return formData;
        }, new FormData());
    }

    public request = async <T = any, _E = any>({
        secure,
        path,
        type,
        query,
        format,
        body,
        ...params
    }: FullRequestParams): Promise<AxiosResponse<T>> => {
        const responseFormat = format;

        if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
            body = this.createFormData(body as Record<string, unknown>);
        }

        if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
            body = JSON.stringify(body);
        }

        return axios.request({
            ...params,
            headers: {
                ...(params.headers || {}),
                ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
                'X-ST-SessionId': this.sessionId,
                'X-ST-CorrelationId': uuidv4(),
                'X-ST-TenantId': this.tenantId,
                'X-ST-TenantFriendlyName': this.tenantFriendlyName,
                'X-ST-ActingUserId': this.actingUserId,
                'X-ST-FIN-Origin': this.requestOrigin,
                'X-ST-FIN-Provider': this.financingProvider,
            },
            params: query,
            responseType: responseFormat,
            data: body,
            url: path,
            paramsSerializer: { indexes: null },
        });
    };
}

export const SESSION_ID_PaymentsApi = symbolToken<string>('SESSION_ID', false);
export const TENANT_ID_PaymentsApi = symbolToken<string>('TENANT_ID', false);
export const TENANT_FRIENDLY_NAME_PaymentsApi = symbolToken<string>('TENANT_FRIENDLY_NAME', false);
export const ACTING_USER_ID_PaymentsApi = symbolToken<string>('ACTING_USER_ID', false);
export const REQUEST_ORIGIN_PaymentsApi = symbolToken<string>('REQUEST_ORIGIN', false);

export const BASE_URL_TOKEN_PaymentsApi = symbolToken<string>('BASE_URL_TOKEN', false);

/**
 * @title v1
 */
@injectable()
export class PaymentsApi extends HttpClient {
    constructor(
        @inject(SESSION_ID_PaymentsApi) @optional() sessionId: string,
        @inject(TENANT_ID_PaymentsApi) @optional() tenantId: string,
        @inject(TENANT_FRIENDLY_NAME_PaymentsApi) @optional() tenantFriendlyName: string,
        @inject(ACTING_USER_ID_PaymentsApi) @optional() actingUserId: string,
        @inject(REQUEST_ORIGIN_PaymentsApi) @optional() requestOrigin: RequestOrigin,
        @inject(BASE_URL_TOKEN_PaymentsApi) @optional() private readonly baseUrl = '',
    ) {
        super(sessionId, tenantId, tenantFriendlyName, actingUserId, requestOrigin);
    }

    public setFinancingProvider(provider: string): void {
        super.setFinancingProvider(provider);
    }

    /**
     * No description
     *
     * @tags CreditCards
     * @name CreditcardsCreate
     * @request POST:/v1/creditcards
     */
    creditcardsCreate = (
        data: PaymentsPaymentMethodsPostCreditCardWrite,
        params: RequestParams = {},
    ) =>
        this.request<CreditcardsCreateData, CreditcardsCreateError>({
            path: `/v1/creditcards`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansUpdate
     * @request PUT:/v1/loans/{id}
     */
    loansUpdate = (
        id: string,
        data: PaymentsServiceContractsRequestsLoansUpsertLoan,
        params: RequestParams = {},
    ) =>
        this.request<LoansUpdateData, LoansUpdateError>({
            path: `/v1/loans/${id}`,
            method: 'PUT',
            baseURL: this.baseUrl,
            body: data,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansDetail
     * @request GET:/v1/loans/{id}
     */
    loansDetail = ({ id, ...query }: LoansDetailParams, params: RequestParams = {}) =>
        this.request<LoansDetailData, void>({
            path: `/v1/loans/${id}`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            ...params,
        });

    /**
     * No description
     *
     * @tags Loans
     * @name LoansList
     * @request GET:/v1/loans
     */
    loansList = (query: LoansListParams, params: RequestParams = {}) =>
        this.request<LoansListData, void>({
            path: `/v1/loans`,
            method: 'GET',
            baseURL: this.baseUrl,
            query: query,
            ...params,
        });

    /**
     * No description
     *
     * @tags Payments
     * @name PaymentsDetail
     * @request GET:/v1/payments/{id}
     */
    paymentsDetail = (id: string, params: RequestParams = {}) =>
        this.request<PaymentsDetailData, void>({
            path: `/v1/payments/${id}`,
            method: 'GET',
            baseURL: this.baseUrl,
            ...params,
        });

    /**
     * No description
     *
     * @tags Payments
     * @name PaymentsPartialUpdate
     * @request PATCH:/v1/payments/{id}
     */
    paymentsPartialUpdate = (
        { id, ...query }: PaymentsPartialUpdateParams,
        params: RequestParams = {},
    ) =>
        this.request<PaymentsPartialUpdateData, PaymentsPartialUpdateError>({
            path: `/v1/payments/${id}`,
            method: 'PATCH',
            baseURL: this.baseUrl,
            query: query,
            ...params,
        });

    /**
     * No description
     *
     * @tags Payments
     * @name PaymentsCreate
     * @request POST:/v1/payments
     */
    paymentsCreate = (data: PaymentsPaymentWrite, params: RequestParams = {}) =>
        this.request<PaymentsCreateData, PaymentsCreateError>({
            path: `/v1/payments`,
            method: 'POST',
            baseURL: this.baseUrl,
            body: data,
            type: ContentType.Json,
            ...params,
        });

    /**
     * No description
     *
     * @tags Payments
     * @name PaymentsPartialUpdate2
     * @request PATCH:/v1/payments
     * @originalName paymentsPartialUpdate
     * @duplicate
     */
    paymentsPartialUpdate2 = (query: PaymentsPartialUpdate2Params, params: RequestParams = {}) =>
        this.request<PaymentsPartialUpdate2Data, PaymentsPartialUpdate2Error>({
            path: `/v1/payments`,
            method: 'PATCH',
            baseURL: this.baseUrl,
            query: query,
            ...params,
        });

    /**
     * No description
     *
     * @tags Transactions
     * @name TransactionsStatusPartialUpdate
     * @request PATCH:/v1/transactions/{id}/status
     */
    transactionsStatusPartialUpdate = (
        id: string,
        data: PaymentsTransactionsHandleTransactionStatusWrite,
        params: RequestParams = {},
    ) =>
        this.request<TransactionsStatusPartialUpdateData, TransactionsStatusPartialUpdateError>({
            path: `/v1/transactions/${id}/status`,
            method: 'PATCH',
            baseURL: this.baseUrl,
            body: data,
            type: ContentType.Json,
            ...params,
        });
}
